import { render, staticRenderFns } from "./ZakatDeclaration.vue?vue&type=template&id=64bf1810&"
import script from "./ZakatDeclaration.vue?vue&type=script&lang=js&"
export * from "./ZakatDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports